import React, { Fragment } from 'react';
import {
	Button,
	Form,
	Header,
	Segment,
	Dropdown,
	Checkbox,
	Grid,
	Modal,
	Table
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';
import { observable, computed, toJS } from 'mobx';
import { withRouter } from 'react-router-dom';
import UiShared from 'stores/UiShared';
import Auth from 'stores/Auth';
import Account from 'stores/Account';
import styles from './styles';
import Prescriber from 'stores/Prescriber';
import PrescriberPractice from 'stores/PrescriberPractice';
import PrescriberPracticeContact from 'stores/PrescriberPracticeContact';
const prescriberTypes = [
	{ text: 'Medical', value: 'Medical' },
	{ text: 'Dental', value: 'Dental' },
	{ text: 'Medical & Dental', value: 'Medical & Dental' }
];
import API from 'api';
import _ from 'lodash';
import Practice from 'stores/Practice';
import * as yup from 'yup';
import MessageBox from 'components/MessageBox';
import MsgStore from 'stores/MsgStore';

@withRouter
@inject(root => ({
	auth: root.auth,
	user: root.auth.user,
	uiShared: root.uiShared
}))
@observer
export default class Edit extends React.Component {
	props: {
		auth?: Auth,
		user?: Account,
		uiShared?: UiShared
	};

	@computed
	get isNew() {
		return !this.oprescriber.id;
	}

	msgStore: MsgStore = new MsgStore();

	@observable oprescriber: Prescriber = new Prescriber();
	@observable oppContact: PrescriberPracticeContact = new PrescriberPracticeContact();
	@observable loading: boolean = false;
	@observable showInviteDlg: boolean = false;
	@observable selectedPracticeId: Number = -1;
	@observable contactSelectedPracticeId: Number = -1;
	@observable dropdownPractices = [];
	@observable selectedPracticeLinkDisabled: boolean = false;

	msgStore = new MsgStore();

	componentDidMount = async () => {
		try {
			const { match, uiShared } = this.props;
			this.loading = true;
			if (match.params.id === '0') {
				this.oprescriber = new Prescriber();
				this.loading = false;
			} else {
				this.oprescriber = await Prescriber.loadById(parseInt(match.params.id));
			}
			const practices = await API.get(`/Practices`);
			this.dropdownPractices = practices.map(el => new Practice(el));
		} finally {
			this.loading = false;
		}
	};

	save = async () => {
		this.msgStore.clear();
		const { oprescriber } = this;
		let uiShared = this.props.uiShared;
		try {
			uiShared.showModal('Saving...');
			oprescriber.isPrescrNoUnique = true;
			if (oprescriber.prescriberNo) {
				let prescrNoUnique = true;
				const prescr = await Prescriber.loadByPrescriberNumber(oprescriber.prescriberNo);
				if (prescr && prescr.length > 0) {
					if (this.isNew) {
						prescrNoUnique = false;
					} else {
						const isCurrent = prescr.length === 1 && prescr[0].id === oprescriber.id;
						if (!isCurrent) {
							prescrNoUnique = false;
						}
					}
				}
				oprescriber.isPrescrNoUnique = prescrNoUnique;
			}
			await this.dataPrescriberValidationSchema.validate(oprescriber, {
				abortEarly: false
			});
			await oprescriber.update();
			await oprescriber.reload();
			this.msgStore.setInfo('The record was saved.');
		} catch (err) {
			console.log(err);
			this.msgStore.setError(err);
		} finally {
			uiShared.hideModal();
		}
	};

	resetModal = () => {
		this.selectedPracticeId = -1;
		this.selectedPracticeLinkDisabled = false;
		this.contactSelectedPracticeId = -1;
		this.oppContact = new PrescriberPracticeContact();
		this.msgStore.clear();
	};

	dataPrescriberValidationSchema = yup.object().shape({
		prescriberName: yup
			.string()
			.label('First Name')
			.required(),
		prescriberSurname: yup
			.string()
			.label('Last Name')
			.required(),
		prescriberNo: yup
			.number()
			.positive('Prescriber Number is a required field.')
			.typeError('Prescriber Number is a required field.')
			.required('Prescriber Number is a required field.'),
		prescriberType: yup
			.string()
			.label('Prescriber Type')
			.required(),
		prescriberNoUnique: yup
			.string()
			.label('Prescriber Number has to be unique.')
			.when('isPrescrNoUnique', {
				is: false,
				then: yup.string().required('Prescriber Number has to be unique.')
			})
	});

	dataContactValidationSchema = yup.object().shape({
		contactName: yup
			.string()
			.label('First Name')
			.required(),
		contactSurname: yup
			.string()
			.label('Last Name')
			.required(),
		contactSelectedPracticeId: yup
			.number()
			.positive('Practice is a required field.')
			.typeError('Practice is a required field.')
			.required('Practice is a required field.'),
		contactEmail: yup
			.string()
			.label('Email Address')
			.required()
	});

	isNumber = evt => {
		evt = evt ? evt : window.event;
		let charCode = evt.which ? evt.which : evt.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	};

	test = () => {
		return false;
	};

	render() {
		const { history } = this.props;
		let {
			oprescriber,
			oppContact,
			selectedPracticeId,
			contactSelectedPracticeId,
			selectedPracticeLinkDisabled
		} = this;
		let contacts = [];
		this.oprescriber?.PrescriberPractices?.forEach(pp => {
			if (pp.PrescriberPracticeContacts?.length > 0) {
				contacts = contacts.concat(
					pp.PrescriberPracticeContacts.map(ppc => {
						return { ...ppc, Practice: pp.Practice };
					})
				);
			}
		});
		contacts = contacts.map((c, idx) => {
			return { ...c, _idx: idx };
		});

		const oprescriberPPs = toJS(this.oprescriber.PrescriberPractices);
		return (
			<Segment loading={this.loading}>
				<Header as="h1">{oprescriber.id ? 'Edit Prescriber Details' : 'Add New Prescriber'}</Header>
				<Grid>
					<Grid.Column style={{ maxWidth: 750 }}>
						<Form>
							<Form.Group className={styles.formGroup}>
								<Form.Input
									label="First Name"
									value={oprescriber.prescriberName || ''}
									onChange={e =>
										(oprescriber.prescriberName = e.target.value?.trim().toUpperCase())
									}
									width={8}
								/>
								<Form.Input
									label="Last Name"
									value={oprescriber.prescriberSurname || ''}
									onChange={e =>
										(oprescriber.prescriberSurname = e.target.value?.trim().toUpperCase())
									}
									width={8}
								/>
								<Form.Input
									label="Prescriber Number"
									value={oprescriber.prescriberNo || ''}
									onKeyPress={false}
									onChange={e => {
										let val = e.target.value;
										val = val.replace(/[^0-9.]/g, '');
										oprescriber.prescriberNo = val;
									}}
									width={8}
								/>
								<Form.Field width={8}>
									<label>Prescriber Type</label>
									<Dropdown
										selection
										placeholder="Select Type"
										value={oprescriber.prescriberType}
										onChange={(e, data) => {
											this.oprescriber.prescriberType = data.value;
										}}
										options={prescriberTypes}
										fluid
									/>
								</Form.Field>
								<Form.Input
									label="Email Address"
									value={oprescriber.prescriberEmail || ''}
									onChange={e => (oprescriber.prescriberEmail = e.target.value)}
									width={8}
								/>
								<Form.Input
									label="Mobile"
									value={oprescriber.prescriberMobile || ''}
									onChange={e => (oprescriber.prescriberMobile = e.target.value)}
									width={8}
								/>
								<div className="sixteen wide field">
									<div className={styles.toggleMargin}>
										<Checkbox
											label="Disable Prescriber"
											checked={oprescriber.disabled || false}
											onChange={() => (oprescriber.disabled = !oprescriber.disabled)}
											toggle
										/>
									</div>
								</div>
								<div className="sixteen wide field">
									<div className={styles.toggleMarginBtm}>
										<Checkbox
											label="API"
											checked={oprescriber.api || false}
											onChange={() => (oprescriber.api = !oprescriber.api)}
											toggle
										/>
									</div>
								</div>
							</Form.Group>

							<Segment>
								<Form.Field>
									<label>Practices Links</label>
									<div className={styles.btnLink}>
										<Button
											primary
											onClick={() => {
												this.resetModal();
												this.selectedPracticeId = 0;
											}}
										>
											Link to Practice
										</Button>
									</div>
								</Form.Field>
								<div>
									{this.oprescriber?.PrescriberPractices?.length > 0 && (
										<Table basic="very" compact="very">
											<Table.Header>
												<Table.Row>
													<Table.HeaderCell>Practice Code</Table.HeaderCell>
													<Table.HeaderCell>Practice Name</Table.HeaderCell>
													<Table.HeaderCell>Address</Table.HeaderCell>
													<Table.HeaderCell>Contact Number</Table.HeaderCell>
													<Table.HeaderCell>Disabled</Table.HeaderCell>
													<Table.HeaderCell>Actions</Table.HeaderCell>
												</Table.Row>
											</Table.Header>
											<Table.Body>
												{toJS(
													this.oprescriber?.PrescriberPractices.filter(el => !el.isDeleted)
												).map((el, idx) => {
													const practice = el?.Practice;
													const address = `${practice?.practiceAddress} ${
														practice?.practicePostcode
													} ${practice?.practiceSuburb} ${practice?.practiceState}`;
													return (
														<Table.Row key={idx}>
															<Table.Cell>{practice?.practiceCode}</Table.Cell>
															<Table.Cell>{practice?.practiceName}</Table.Cell>
															<Table.Cell>{address}</Table.Cell>
															<Table.Cell>{practice?.practicePhone}</Table.Cell>
															<Table.Cell>
																<Checkbox checked={el?.disabled} readOnly />
															</Table.Cell>
															<Table.Cell>
																<Button
																	icon="edit"
																	size="mini"
																	label="Edit"
																	primary
																	onClick={() => {
																		this.selectedPracticeId = practice?.id;
																		this.selectedPracticeLinkDisabled = el?.disabled;
																	}}
																/>
															</Table.Cell>
														</Table.Row>
													);
												})}
											</Table.Body>
										</Table>
									)}
								</div>
							</Segment>

							{/*<Segment>*/}
							{/*<Form.Field>*/}
							{/*<label>Contacts</label>*/}
							{/*<div className={styles.btnLink}>*/}
							{/*<Button*/}
							{/*primary*/}
							{/*onClick={() => {*/}
							{/*this.resetModal();*/}
							{/*this.contactSelectedPracticeId = 0;*/}
							{/*}}*/}
							{/*>*/}
							{/*Add Contact*/}
							{/*</Button>*/}
							{/*</div>*/}
							{/*</Form.Field>*/}
							{/*<div>*/}
							{/*{contacts.length > 0 && (*/}
							{/*<Table basic="very" compact="very">*/}
							{/*<Table.Header>*/}
							{/*<Table.Row>*/}
							{/*<Table.HeaderCell>Practice Code</Table.HeaderCell>*/}
							{/*<Table.HeaderCell>Practice</Table.HeaderCell>*/}
							{/*<Table.HeaderCell>Contact name</Table.HeaderCell>*/}
							{/*<Table.HeaderCell>Contact email</Table.HeaderCell>*/}
							{/*<Table.HeaderCell>Disabled</Table.HeaderCell>*/}
							{/*<Table.HeaderCell>Actions</Table.HeaderCell>*/}
							{/*</Table.Row>*/}
							{/*</Table.Header>*/}
							{/*<Table.Body>*/}
							{/*{toJS(contacts.filter(el => !el.isDeleted)).map((el, idx) => {*/}
							{/*const practice = el?.Practice;*/}
							{/*return (*/}
							{/*<Table.Row key={idx}>*/}
							{/*<Table.Cell>{practice?.practiceCode}</Table.Cell>*/}
							{/*<Table.Cell>{practice?.practiceName}</Table.Cell>*/}
							{/*<Table.Cell>{`${el?.contactName} ${el?.contactSurname}`}</Table.Cell>*/}
							{/*<Table.Cell>{el?.contactEmail}</Table.Cell>*/}
							{/*<Table.Cell>*/}
							{/*<Checkbox checked={el?.disabled} readOnly />*/}
							{/*</Table.Cell>*/}
							{/*<Table.Cell>*/}
							{/*<Button*/}
							{/*icon="edit"*/}
							{/*size="mini"*/}
							{/*label="Edit"*/}
							{/*primary*/}
							{/*onClick={() => {*/}
							{/*this.oppContact = _.find(contacts, { _idx: el._idx });*/}
							{/*this.contactSelectedPracticeId = this.oppContact?.Practice?.id;*/}
							{/*}}*/}
							{/*/>*/}
							{/*</Table.Cell>*/}
							{/*</Table.Row>*/}
							{/*);*/}
							{/*})}*/}
							{/*</Table.Body>*/}
							{/*</Table>*/}
							{/*)}*/}
							{/*</div>*/}
							{/*</Segment>*/}
							<div className={styles.buttonsBottom}>
								<Button
									disabled={this.isLoading}
									primary
									onClick={() => this.save()}
									floated="left"
								>
									Save
								</Button>
								<Button onClick={() => history && history.goBack()} floated="left">
									Back
								</Button>
								<div className={styles.clear} />
							</div>
						</Form>
					</Grid.Column>
				</Grid>

				<MessageBox msgStore={this.msgStore} />
				<Modal
					open={this.selectedPracticeId > -1}
					onClose={() => {
						this.resetModal();
					}}
					closeOnDimmerClick={false}
				>
					<Modal.Header>Link to Practice</Modal.Header>
					<Modal.Content>
						<Form>
							<Form.Field width={8}>
								<label>Select Practice</label>
								<Dropdown
									selection
									search
									placeholder="Select Practice"
									value={selectedPracticeId}
									onChange={(e, data) => {
										this.selectedPracticeId = data.value;
									}}
									options={toJS(this.dropdownPractices)
										.filter(p => {
											if (p.id === this.selectedPracticeId) {
												return true;
											} else {
												return !_.find(oprescriberPPs, { practiceID: p.id });
											}
										})
										.map(p => ({
											text: p?.practiceName,
											value: p.id
										}))}
									fluid
								/>
							</Form.Field>
							<div className={styles.toggleMargin}>
								<Checkbox
									label="Disable Link"
									checked={selectedPracticeLinkDisabled || false}
									onChange={() =>
										(this.selectedPracticeLinkDisabled = !this.selectedPracticeLinkDisabled)
									}
									toggle
								/>
							</div>
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button
							negative
							onClick={() => {
								this.resetModal();
							}}
						>
							Cancel
						</Button>
						<Button
							primary
							floated="left"
							disabled={!this.selectedPracticeId}
							onClick={() => {
								if (!this.selectedPracticeId) return;
								const practiceIdToAdd = this.selectedPracticeId;
								const idx = _.findIndex(oprescriberPPs, {
									practiceID: practiceIdToAdd
								});
								if (idx === -1) {
									const selected = _.find(toJS(this.dropdownPractices), { id: practiceIdToAdd });
									this.oprescriber.PrescriberPractices.push(
										new PrescriberPractice({
											practiceID: practiceIdToAdd,
											disabled: this.selectedPracticeLinkDisabled,
											isDeleted: false,
											Practice: {
												...selected
											}
										})
									);
								} else {
									const item = this.oprescriber.PrescriberPractices[idx];
									if (item.isDeleted === true) {
										this.oprescriber.PrescriberPractices.splice(idx, 1);
										this.oprescriber.PrescriberPractices.push({ ...item, isDeleted: false });
									} else {
										item.disabled = this.selectedPracticeLinkDisabled;
									}
								}
								this.resetModal();
							}}
						>
							Save
						</Button>
					</Modal.Actions>
				</Modal>
				<Modal
					open={this.contactSelectedPracticeId > -1}
					onClose={() => {
						this.resetModal();
					}}
					closeOnDimmerClick={false}
				>
					<Modal.Header>Contact Details</Modal.Header>
					<Modal.Content>
						<Form>
							<MessageBox msgStore={this.msgStore} />
							<Form.Group className={styles.formGroup}>
								<Form.Input
									label="First Name"
									value={oppContact.contactName || ''}
									onChange={e => (this.oppContact.contactName = e.target.value)}
									width={8}
								/>
								<Form.Input
									label="Last Name"
									value={oppContact.contactSurname || ''}
									onChange={e => (this.oppContact.contactSurname = e.target.value)}
									width={8}
								/>
								<Form.Field width={8}>
									<label>Select Practice</label>
									<Dropdown
										selection
										placeholder="Select Practice"
										value={contactSelectedPracticeId || ''}
										onChange={(e, data) => {
											this.contactSelectedPracticeId = data.value;
										}}
										options={toJS(this.dropdownPractices)
											.filter(p => {
												return _.find(this.oprescriber?.PrescriberPractices, {
													practiceID: p.id,
													disabled: false
												});
											})
											.map(p => ({
												text: p?.practiceName,
												value: p.id
											}))}
										fluid
									/>
								</Form.Field>
								<Form.Input
									label="Email Address"
									value={oppContact.contactEmail || ''}
									onChange={e => (this.oppContact.contactEmail = e.target.value)}
									width={8}
								/>
								<Form.Input
									label="Phone"
									value={oppContact.contactPhone || ''}
									onChange={e => (this.oppContact.contactPhone = e.target.value)}
									width={8}
								/>
								<Form.Input
									label="Mobile"
									value={oppContact.contactMobile || ''}
									onChange={e => (this.oppContact.contactMobile = e.target.value)}
									width={8}
								/>
							</Form.Group>
							<div className={styles.toggleMargin}>
								<Checkbox
									label="Disable Link"
									checked={oppContact.disabled || false}
									onChange={() => (this.oppContact.disabled = !this.oppContact.disabled)}
									toggle
								/>
							</div>
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button
							negative
							onClick={() => {
								this.resetModal();
							}}
						>
							Cancel
						</Button>
						<Button
							primary
							floated="left"
							onClick={async () => {
								try {
									this.msgStore.clear();
									const pp = _.find(this.oprescriber?.PrescriberPractices, {
										practiceID: this.contactSelectedPracticeId
									});
									const values = JSON.parse(JSON.stringify(this.oppContact));
									values.contactSelectedPracticeId = this.contactSelectedPracticeId;
									await this.dataContactValidationSchema.validate(values, {
										abortEarly: true
									});
									pp.PrescriberPracticeContacts.push(new PrescriberPracticeContact({ ...values }));
									this.resetModal();
								} catch (e) {
									this.msgStore.setError(e);
								}
							}}
						>
							Save
						</Button>
					</Modal.Actions>
				</Modal>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/routes/Admin/Prescribers/Edit.js